
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Selon Curevac, ce vaccin peut être stocké au moins trois mois à 5 degrés, et
rester 24 heures à température ambiante.`}</p>
    <p>{`De façon générale, les vaccins à ARNm peuvent être modifiés plus rapidement que
leurs homologues utilisant des techniques traditionnelles, ce qui est un
avantage face aux variants.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;